import React from "react";
import { useNavigate } from "react-router-dom";
import { Grid2 } from "@mui/material";
// styles
import styles from "./FailedPage.module.scss";
// Icons
import { ReactComponent as CloneSite } from "../../../../AdminAssets/svg/CloneSite.svg";

export default function FailedPage({ selectedOrg }) {
  const orgId =  selectedOrg?.orgId ? selectedOrg?.orgId : -1;
  const navigate = useNavigate();

  return (
    <Grid2 className={styles.FailedPageContainer}>
      <Grid2 className={styles.ready}>
        <Grid2
          className={styles.lastpage}
          onClick={() => navigate(`/account/${orgId}/sites-overview`)}
        >
          <CloneSite className={styles.icon} />
          <Grid2 className={styles.edit}>Go to Rocon Control Panel</Grid2>
          <Grid2 className={styles.wordPressDis}>
            <Grid2 className={styles.panel}>Manage Sites</Grid2>
          </Grid2>
        </Grid2>
        <Grid2
          className={styles.lastpage}
          onClick={() => window.location.reload()}
        >
          <CloneSite className={styles.icon} />
          <Grid2 className={styles.edit}>Something went worng</Grid2>
          <Grid2 className={styles.panel1}>Try Again</Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
}
